import React from "react"
import { Tabs as TabsMaterial } from "@mui/material"
import { Tab, TabProps } from "../../atoms/tab"
import styled, { css } from "styled-components"
import { theme } from "../../../theme"

export enum TabsGroupVariant {
  fullWidth = "fullWidth",
  scrollable = "scrollable",
  standard = "standard",
}

export type TabsGroupProps = {
  selectedTab: string
  tabsProps: TabProps[]
  onChange: (value: string) => void
  backgroundColor?: string
  paddingTop?: string
  variant?: TabsGroupVariant
  bottomSeparator?: boolean
}

export const TabsGroup = (props: TabsGroupProps) => {
  const {
    selectedTab,
    tabsProps,
    variant = TabsGroupVariant.scrollable,
    onChange,
    backgroundColor,
    paddingTop,
    bottomSeparator,
    ...rest
  } = props

  const handleOnChange = (_event: React.ChangeEvent<{}>, newValue: string) => {
    onChange(newValue)
  }

  return (
    <CustomTabs
      value={selectedTab}
      onChange={handleOnChange}
      indicatorColor="primary"
      textColor="primary"
      variant={variant}
      $backgroundColor={backgroundColor}
      $paddingTop={paddingTop}
      scrollButtons="auto"
      allowScrollButtonsMobile
      $bottomSeparator={bottomSeparator}
      {...rest}
    >
      {tabsProps.map((tab, index) => (
        <Tab key={index} {...tab} />
      ))}
    </CustomTabs>
  )
}

const CustomTabs = styled(TabsMaterial)<{
  $backgroundColor?: string
  $paddingTop?: string
  $bottomSeparator?: boolean
}>`
  ${(p) =>
    p.$backgroundColor &&
    css`
      background-color: ${p.$backgroundColor};
    `}

  ${(p) =>
    p.$paddingTop &&
    css`
      padding-top: ${p.$paddingTop};
    `}

    ${(p) =>
    p.$bottomSeparator &&
    css`
      &:before {
        content: "";
        position: absolute;
        display: block;
        margin-top: 48px;
        height: 1px;
        width: 100%;
        background: ${theme.color.white1};
        left: 0;
      }
    `}
`
